import moment from 'moment';

/**
 * Output dates have to be at least one year from start date.
 * Output dates have to be at least 50 days into the future from NOW.
 */
function createCPIAdjustmentDateOptions(tenancyStartDate, dueDay, now) {
  const output = [];
  const dateFormat = 'YYYY-MM-DD';

  if (!tenancyStartDate) return output;

  const requiredOutputSize = 35;
  const minDaysIntoTheFuture = 50;
  let index = 0;

  // Keeping this as is for regression.
  dueDay = dueDay || 1;

  tenancyStartDate = moment(tenancyStartDate);

  // First reference, Tenancy Start date + 1 full year.
  const tenancyStartDatePlusOneYear = tenancyStartDate.clone().add(1, 'years');

  // Second reference - Using the now date proviced and setting the date to
  // the dueday.
  const suggestedDate = moment(now).set('date', dueDay);

  // minDaysIntoTheFuture from NOW
  const minDaysIntoFuture = moment(now).add(minDaysIntoTheFuture, 'days');

  while (index < requiredOutputSize) {
    if (suggestedDate.isSameOrAfter(tenancyStartDatePlusOneYear) && suggestedDate.isSameOrAfter(minDaysIntoFuture)) {
      output.push(suggestedDate.format(dateFormat));
      index++;
    }
    suggestedDate.add(1, 'months');
  }

  //console.table(output);
  return output;
}

export { createCPIAdjustmentDateOptions };
